import * as Common from '../Common/modules';
import * as Models from '../Models';

export interface IPartnerApiClientService {
  getPartners(excludeUsersGroups?: boolean): ng.IPromise<Models.PartnerModel.IPartnerModel[]>;
  getPartnerByCode(partnerCode: string): ng.IPromise<Models.PartnerModel.IPartnerModel>;
}

export class PartnerApiClientService implements IPartnerApiClientService {
  public routePrefix = 'Admin';

  public static $inject = ['igs.apiClientService'];

  constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {}

  public getPartners(excludeUsersGroups?: boolean): angular.IPromise<Models.PartnerModel.IPartnerModel[]> {
    var url = `${this.routePrefix}/Partners` + (excludeUsersGroups ? '?excludeUsersGroups=1' : '');
    return this.igsApiClientService.get(url);
  }

  public getPartnerByCode(partnerCode: string): angular.IPromise<Models.PartnerModel.IPartnerModel> {
    var url = `${this.routePrefix}/Partner/${partnerCode}`;
    return this.igsApiClientService.get(url);
  }
}
